<template>
  <div style="height:305px;width:100%;" class="pt10">
    <title-msg :titleMsg="titleMsg"></title-msg>
    <div>
      <div :class="className" v-show="isShow" id="ring" :style="{height:height,width:width}" />
			<div v-show="!isShow" style="color: #fff;margin-top: 68px;">暂无数据</div>
    </div>
  </div>
  <!-- <div :class="className" :style="{height:height,width:width}" /> -->
</template>

<script>
import echarts from "echarts";
require("echarts/theme/macarons"); // echarts theme
import resize from "./mixins/resize";
import titleMsg from "../../../components/titleMsg";
// import noData from "@/views/components/nodata";
export default {
  components: {
		// noData,
		titleMsg
  },
  mixins: [resize],
  props: {
    className: {
      type: String,
      default: "chart"
    },
    width: {
      type: String,
      default: "100%"
    },
    height: {
      type: String,
      default: "290px"
    },
    chartData: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
			isShow:true,
			titleMsg:'报警频率统计 TOP3',
      chart: null,
      activeName: "first",
      attrName: [],
      attrCount: [],
      chartColors: ["#01a5ed", "#02dcc3", "#73df2b"],
      data: [],
      radio1: "12"
    };
  },
  watch: {
    chartData: {
      deep: true,
      handler(newVal) {
        // newVal.attrName.forEach((name, index) => {
        //   this.data = [];
        //   this.data.push({
        //     name: name,
        //     value: newVal.attrCount[index],
        //     attr: name.substring(0, name.lastIndexOf("-"))
        //   });
				// });
				this.setOptions(newVal)
      }
    }
  },
  mounted() {
    // this.$nextTick(() => {
    //   this.initChart();
		// });
		setTimeout(
    () => {
        //  this.initChart();
   },100)
  },
  updated() {
    if (this.chartData) {
      this.setOptions(this.chartData);
    }
  },
  beforeDestroy() {
    if (!this.chart) {
      return;
    }
    this.chart.dispose();
    this.chart = null;
  },
  created() {},
  methods: {
    initChart() {
      this.chart = echarts.init(document.getElementById("ring"));
      this.setOptions(this.chartData);
    },
    setOptions({ attrCount, attrName }) {
			this.attrName = attrName;
			let is =attrCount.every( (value, index) =>value>0)
			if(attrCount.length==1&&!is){
				this.isShow = false
				return
			}else{
					this.isShow = true
			}
      this.attrCount = attrCount;
      let bgColor = "#fff";
      let title = "总量";
      let color = this.chartColors;
      let echartData = [];
      if (attrName.length > 0) {
        attrName.forEach((name, index) => {
          echartData.push({
            name: name,
            value: attrCount[index]
          });
        });
      }

      let formatNumber = function(num) {
        let reg = /(?=(\B)(\d{3})+$)/g;
        return num.toString().replace(reg, ",");
      };
      let total = echartData.reduce((a, b) => {
        return a + b.value * 1;
      }, 0);

      if (this.chart) {
        this.chart.clear();
      } else {
        this.chart = echarts.init(document.getElementById("ring"));
      }
      var option = {
        title: {
          textStyle: {
            color: "#fff"
          },
          subtextStyle: {
            color: "#999"
          },
          x: "center",
          top: "0%"
        },
        grid: {
					top: 30,
					left:10,
					right: 10,
          bottom: 60
        },
        tooltip: {},
        xAxis: {
          data:  this.attrName,
          axisTick: {
            show: false
          },
          axisLine: {
            show: false,
            lineStyle: {
              color: "#6db7d1", //纵向网格线颜色
              width: 1
            }
          },
          axisLabel: {
            show: true,
            textStyle: {
              color: "#ffffff",
							
						},
						fontSize: 12,
							margin:30,
          }
        },
        yAxis: {
          // name: "总数（次）",
          nameTextStyle: {
            color: "#fff",
            fontSize: 12
          },
          splitLine: {
            show: false
          },
          axisTick: {
            show: false
          },
          axisLine: {
            show: false,
            lineStyle: {
              color: "#6db7d1", //纵向网格线颜色
              width: 1
            }
          },
          axisLabel: {
            show: false,
            textStyle: {
              color: "#ffffff"
            }
          }
        },
        series: [
          {
            name: "",
            type: "pictorialBar",
            symbolSize: [30, 5],
            symbolOffset: [0, -4],
            z: 1,
            data: [
              {
                name: this.attrName[0] || '',
                value: this.attrCount[0] || '',
                trueVal: "499",
                symbolPosition: "end",
                itemStyle: {
                  normal: {
                    color: "#eba7ba"
                  }
                }
              },
              {
                name: this.attrName[1] || '',
                value:  this.attrCount[1] || '',
                trueVal: "499",
                symbolPosition: "end",
                itemStyle: {
                  normal: {
                    color: "#c7ab7e"
                  }
                }
              },
              {
                name: this.attrName[2],
                value:  this.attrCount[2],
                trueVal: "2",
                symbolPosition: "end",
                itemStyle: {
                  normal: {
                    color: "#57a6a3"
                  }
                }
              }
            ]
          },
          {
            name: "",
            type: "pictorialBar",
            symbolSize: [30, 5],
            symbolOffset: [0, 0],
            z: 12,
            data: [
              {
                name: this.attrName[0] || '',
                value:  this.attrCount[0] || '',
                trueVal: "98",
                itemStyle: {
                  normal: {
                    color: "#eba7ba"
                  }
                }
              },
              {
                name: this.attrName[1],
                value: this.attrCount[1],
                trueVal: "499",
                itemStyle: {
                  normal: {
                    color: "#c7ab7e"
                  }
                }
              },
              {
                name:this.attrName[2],
                value:  this.attrCount[2],
                trueVal: "2",
                itemStyle: {
                  normal: {
                    color: "#57a6a3"
                  }
                }
              }
            ]
          },
          {
            name: "",
            type: "pictorialBar",
            symbolSize: [55, 20],
            symbolOffset: [0, 8],
            z: 11,
            data: [
              {
                name: this.attrName[0] || '',
                value:  this.attrCount[0] || '',
                trueVal: "98",
                itemStyle: {
                  normal: {
                    color: "transparent",
                    borderColor: "#3ACDC5",
                    borderWidth: 2
                  }
                }
              },
              {
                name: this.attrName[1],
                value:  this.attrCount[1],
                trueVal: "4",
                itemStyle: {
                  normal: {
                    color: "transparent",
                    borderColor: "#3ACDC5",
                    borderWidth: 2
                  }
                }
              },
              {
                name: this.attrName[2],
                value:  this.attrCount[2],
                trueVal: "2",
                itemStyle: {
                  normal: {
                    color: "transparent",
                    borderColor: "#3ACDC5",
                    borderWidth: 2
                  }
                }
              }
            ]
          },
          {
            name: "",
            type: "pictorialBar",
            symbolSize: [85, 30],
            symbolOffset: [0, 15],
            z: 10,
            data: [
              {
                name: this.attrName[0],
                value:  this.attrCount[0],
                trueVal: "98",
                itemStyle: {
                  normal: {
                    color: "transparent",
                    borderColor: "#02C3F1",
                    // "borderType": "dashed",
                    borderWidth: 2
                  }
                }
              },
              {
                name: this.attrName[1],
                value:  this.attrCount[1],
                trueVal: "499",
                itemStyle: {
                  normal: {
                    color: "transparent",
                    borderColor: "#02C3F1",
                    // "borderType": "dashed",
                    borderWidth: 2
                  }
                }
              },
              {
                name: this.attrName[2],
                value:  this.attrCount[2],
                trueVal: "2",
                itemStyle: {
                  normal: {
                    color: "transparent",
                    borderColor: "#02C3F1",
                    // "borderType": "dashed",
                    borderWidth: 2
                  }
                }
              }
            ]
          },
          {
            type: "bar",
            silent: true,
            barWidth: 30,
            barGap: "-100%",
            label: {
              normal: {
                show: true,
                position: "top",
								distance: 10,
								 color:"#fff"
                // show: false
              }
            },
            data: [
              {
                name: this.attrName[0],
                value:  this.attrCount[0],
                trueVal: "98",
                itemStyle: {
                  normal: {
                    color: {
                      x: 0,
                      y: 0,
                      x2: 0,
                      y2: 1,
                      type: "linear",
                      global: false,
                      colorStops: [
                        {
                          offset: 0,
                          color: "rgba(225,119,149, 0.2)"
                        },
                        {
                          offset: 1,
                          color: "#e17795"
                        }
                      ]
                    }
                  }
                }
              },
              {
                name: this.attrName[1],
                value:  this.attrCount[1],
                trueVal: "4",
                itemStyle: {
                  normal: {
                    color: {
                      x: 0,
                      y: 0,
                      x2: 0,
                      y2: 1,
                      type: "linear",
                      global: false,
                      colorStops: [
                        {
                          offset: 0,
                          color: "rgba(167,130,70, 0.2)"
                        },
                        {
                          offset: 1,
                          color: "#a78246"
                        }
                      ]
                    }
                  }
                }
              },
              {
                name: this.attrName[2],
                value:  this.attrCount[2],
                trueVal: "2",
                itemStyle: {
                  normal: {
                    color: {
                      x: 0,
                      y: 0,
                      x2: 0,
                      y2: 1,
                      type: "linear",
                      global: false,
                      colorStops: [
                        {
                          offset: 0,
                          color: "rgba(156,207,201,0.2)"
                        },
                        {
                          offset: 1,
                          color: "#9ccfc9"
                        }
                      ]
                    }
                  }
                }
              }
            ]
          }
        ]
      };
      this.chart.setOption(option);
    },
    handleClick(tab, event) {
      console.log(tab, event);
    },
    changeRadio(value) {
      let time = value.replace(/[^\d]/g, "");
      // this.getAlarmChartStatistics(time);
    }
  }
};
</script>

<style lang="scss" scoped>
.radio-group-box {
  text-align: center;
  margin-top: 20px;
}
.summary {
  overflow: hidden;
  .totle {
    color: #666666;
    font-size: 14px;
    text-align: center;
  }
  .progress {
    width: 100%;
    text-align: center;
    // margin-left: -45px;
    // margin-right: 10px;
    .el-progress {
      width: calc(100% - 120px);
      display: inline-block;
    }
  }
}

.btn-box {
  display: flex;
  justify-content: center;
  margin-top: -25px;
  margin-left: 290px;
  span {
    display: inline-block;
    width: 80px;
    height: 33px;
    text-align: center;
    line-height: 32px;
    vertical-align: middle;
    cursor: pointer;
    &.btnMonth {
      background-color: #ffffff;
      border-radius: 16px 0px 0px 16px;
      border: solid 1px #209b9a;
      color: #209b9a;
    }
    &.btnYear {
      background-color: #ffffff;
      border-radius: 0px 16px 16px 0px;
      border: solid 1px #209b9a;
      color: #209b9a;
      margin-left: -5px;
    }
    &.active {
      background-color: #209b9a;
      border-radius: 16px 0px 0px 16px;
      color: #fff;
    }
    &.actives {
      background-color: #209b9a;
      // border-radius: 16px 0px 0px 16px;
      color: #fff;
    }
  }
}
.month-box {
  float: right;
  width: 310px;
  text-align: right;
  span {
    font-size: 16px;
    margin: 0 20px;
  }
  .one::before {
    content: "";
    height: 18px;
    width: 18px;
    background-color: #9b7fdb;
    border-radius: 50%;
    display: inline-block;
    vertical-align: middle;
    margin-right: 10px;
  }
  .two::before {
    content: "";
    height: 18px;
    width: 18px;
    background-color: #eb416d;
    border-radius: 50%;
    display: inline-block;
    vertical-align: middle;
    margin-right: 10px;
  }
  .three::before {
    content: "";
    height: 18px;
    width: 18px;
    background-color: #f9b83f;
    border-radius: 50%;
    display: inline-block;
    vertical-align: middle;
    margin-right: 10px;
  }
}

.progress-row {
  align-items: center;
  display: flex;
}

.progress-box {
  display: flex;
  align-items: center;
  margin: 30px;
  .progress {
    width: 50px;
    border-radius: 9px;
    height: 18px;
  }
  .progress-txt {
    font-size: 13px;
    color: #333;
    margin: 0 12px 0 8px;
  }
}
</style>
